export const productDetailPageMap = {
    'sale' : '/product-details',
    'bank' : '/pallet-bank-details',
    'rent' : '/lease-product-details',
}